import { useInvestigationDetails } from '@hooks/useInvestigationDetails';
import MultipleChoiceQuestionComponent from './multipleChoiceQuestion';
import { questionType } from '@/types/QuestionTypes';
import OpenQuestion from './OpenQuestion';
import { useQuestionMetrics } from '@hooks/useQuestionMetrics';
import { CheckQuestion } from './CheckQuestion/CheckQuestion';
import { NAICSQuestion } from '@components/Questions/NAICSQuestion/NAICSQuestion';
import { CTRQuestion } from '@components/Questions/CTRQuestion/CTRQuestion';

interface IQuestionsProps {
	questionId: string;
	setCurrentAnswer: (answerId: any, answerText?: any) => void;
	handleCheckboxChange?: (value: boolean) => void;
	isTextInputInvalid?: boolean;
	isSelectInvalid?: boolean;
	isCheckboxInvalid?: boolean;
	required?: boolean;
}

export interface SessionMetrics {
	questionId: string;
	openedTime: number;
}

export default function QuestionComponent(props: IQuestionsProps) {
	const investigationDetails = useInvestigationDetails();
	useQuestionMetrics({ questionId: props.questionId });

	if (investigationDetails?.nextQuestion == null) return null;
	if (investigationDetails?.nextQuestion?.type === questionType.DYNAMIC_OPTIONS_QUESTION) {
		return (
			<NAICSQuestion
				isSelectInvalid={props.isSelectInvalid ?? false}
				setCurrentAnswer={props.setCurrentAnswer}
				questionText={investigationDetails.nextQuestion.questionText}
			/>
		);
	}
	if (investigationDetails?.nextQuestion?.type === questionType.OUCF_CHECK_QUESTION)
		return (
			<CheckQuestion
				isCheckboxInvalid={props.isCheckboxInvalid ?? false}
				isTextInputInvalid={props.isTextInputInvalid ?? false}
				setCurrentAnswer={props.setCurrentAnswer}
				setCheckSubmittingCheckbox={props.handleCheckboxChange}
			/>
		);

	if (investigationDetails?.nextQuestion?.type === questionType.CTR_QUESTION) {
		return (
			<CTRQuestion
				setCurrentAnswer={props.setCurrentAnswer}
				setCTRCheckbox={props.handleCheckboxChange}
				isCheckboxInvalid={props.isCheckboxInvalid ?? false}
			/>
		);
	}
	if (investigationDetails.nextQuestion?.type === questionType.MULTIPLECHOICE)
		return (
			<MultipleChoiceQuestionComponent
				isTextInputInvalid={props.isTextInputInvalid ?? false}
				setCurrentAnswer={props.setCurrentAnswer}
				questionId={props.questionId}
			/>
		);
	if (investigationDetails.nextQuestion?.type === questionType.OPENANSWER)
		return (
			<OpenQuestion
				required={props.required ?? false}
				isTextInputInvalid={props.isTextInputInvalid ?? false}
				setCurrentAnswer={props.setCurrentAnswer}
				questionId={props.questionId}
			/>
		);
	else return null;
}
